import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardServiceService } from '../../services/dashboard-service.service';


@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.css'],
})
export class BodyComponent implements OnInit {
  data: any;
  constructor(
    private dashboardService: DashboardServiceService,
    private dialog: MatDialog
  ) {
    // method to handle any additional initialization tasks.
  }

  ngOnInit(): void {
    //
  }
  
}
